/** @format */

import { Component } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertInfoFilled
} from '@dsg-tech/homefield-angular-icons';

import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
@Component({
	selector: 'pdp-return-policy',
	templateUrl: './return-policy.component.html',
	styleUrl: './return-policy.component.scss',
	imports: [HmfTextLinkComponent, HomefieldIconLibraryModule]
})
export class ReturnPolicyComponent {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoFilled]);
	}
	public returnPolicyMessage = {
		returnPolicyName: 'Bikes',
		returnPolicyContent:
			'Unused bikes are eligible for return up to 24 hours after in store purchase, pick-up, or home delivery.',
		returnPolicyUrl: '/s/return-policy'
	};
}
